<template>
  <div v-if="alarmGroupsOptions.length" class="my-1">
    <p class="lead text-center font-medium-3">
        {{ $tc("alarm_groups.group", 1) }}
    </p>
    <b-form
      @submit.prevent="handleSubmit(onSubmit)"
      @reset.prevent="resetForm"
    >
      <!-- Alarm groups -->
      <validation-provider
        #default="validationContext"
        name="alarm_groups"
      >
        <b-form-group
          class="text-capitalize"
          :label="$t('alarm_groups.select')"
          label-for="alarm_groups"
        >
          <v-select
            v-model="alarmGruops"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :clearable="false"
            label="name"
            :options="alarmGroupsOptions"
            multiple
            :disabled="loading"
            @input="alarmGroupSelected($event)"
          />
          <b-form-invalid-feedback>
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>
    </b-form>
  </div>
</template>

<script>
import { computed,onMounted,ref } from '@vue/composition-api';
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";
import vSelect from 'vue-select';
import Ripple from "vue-ripple-directive";
import store from "@/store";

export default {
  props: {
    alarm: Object
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect
  },
  directives: {
    Ripple,
  },
  setup (props) {
    //HOOKS
    onMounted(async () => {
      store.commit('alarm/setAlarmGroups', []);

      checkAlarmGroups();
      await getAlarmGroups();
    });

    //COMPOSABLES
    const toast = useToast();

    //DATA
    const alarmGroupsOptions = ref([]);

    const alarmRequest = ref({
      id_alarm: null,
      banamex_institutions: []
    });

    //COMPUTED
    const alarmGruops = computed({
      get: () => store.getters['alarm/getAlarmGroups'],
      set: (newValue) => store.commit('alarm/setAlarmGroups', newValue)
    });

    const loading = computed(() => store.getters['alarm/getLoading']);

    //METHODS
     const alarmGroupSelected = async (values) => {
      store.commit('alarm/setLoading', true);

      const groupsSelected = (values.length)
      ? values.map(ag => ag.id)
      : [];

      const params = {
        id_alarm: props.alarm.id,
        alarm_groups: groupsSelected
      }

      await store.dispatch('alarm/alarmGroups', params)
        .then(response => {
          const { message } = response;

          toast({
            component: ToastificationContent,
            props: {
              title: message,
              icon: "CheckIcon",
              variant: "success",
            },
          });
        })
        .catch(error => {
          toast({
              component: ToastificationContent,
              props: {
                title: error.response.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            })
        })
        .finally(() => {
           store.commit('alarm/setLoading', false);
        });
    }

    const checkAlarmGroups = () => {
      const { alarm_groups } = props.alarm;


      store.commit('alarm/setAlarmGroups', alarm_groups);
    }

    const getAlarmGroups = async () => {
      store.commit('alarm/setLoading', true);

      await store.dispatch('alarm_groups/getAll')
        .then(response => {
          const { data } = response;

          alarmGroupsOptions.value = data;
        })
        .catch(() => {
          alarmGroupsOptions.value = []
        })
        .finally(() => {
          store.commit('alarm/setLoading', false);
        });
    }

    return {
      alarmGroupsOptions,
      alarmRequest,
      loading,

      alarmGruops,

      alarmGroupSelected
    }
  }
}
</script>
